export default function getVolume(l, w, d) {
  return (((Math.PI / 6) * (Number(l) * Number(w) * Number(d))) / 1000).toFixed(
    3
  );
}
